import { create } from 'zustand';
const useMultiBroadcasterOutput = create(() => ({
    ready: false,
    isVideoStreaming: false,
    audioMuted: true,
    watchingStartedAt: undefined,
    broadcastedVideoQuality: 'sd', // TODO: MULTIBROADCASTER - add handling of this when implementing the broadcasting in MultiBroadcasterService
}));
const reactiveOutput = {
    useReady: () => {
        return useMultiBroadcasterOutput((s) => s.ready);
    },
    useIsVideoStreaming: () => {
        return useMultiBroadcasterOutput((s) => s.isVideoStreaming);
    },
    useAudioMuted: () => {
        return useMultiBroadcasterOutput((s) => s.audioMuted);
    },
    useWatchingStartedAt: () => {
        return useMultiBroadcasterOutput((s) => s.watchingStartedAt);
    },
    useBroadcastedVideoQuality: () => {
        return useMultiBroadcasterOutput((s) => s.broadcastedVideoQuality);
    },
};
export class MultiBroadcasterServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setReady(ready) {
        useMultiBroadcasterOutput.setState({ ready });
    }
    setIsVideoStreaming(isVideoStreaming) {
        useMultiBroadcasterOutput.setState({ isVideoStreaming });
    }
    setAudioMuted(audioMuted) {
        useMultiBroadcasterOutput.setState({ audioMuted });
    }
    getAudioMuted() {
        return useMultiBroadcasterOutput.getState().audioMuted;
    }
    setWatchingStartedAt(watchingStartedAt) {
        useMultiBroadcasterOutput.setState({ watchingStartedAt });
    }
    getWatchingStartedAt() {
        return useMultiBroadcasterOutput.getState().watchingStartedAt;
    }
}
